import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {IziviaDeviceService} from '../services/common/iziviaDevice.service';

@Injectable({
    providedIn: 'root'
})
export class DeviceInterceptor implements HttpInterceptor {
    private static readonly HEADER_NAME = 'X-DEVICE-ID';

    constructor(private readonly deviceService: IziviaDeviceService) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.deviceService.deviceId$
            .pipe(
                map(uuid => req.headers.append(DeviceInterceptor.HEADER_NAME, uuid)),
                switchMap(headers => next.handle(
                    req.clone({
                        headers: headers
                    })
                ))
            );
    }
}
